import { apiFetch } from './apiBase';

export interface EpisodeSnapshot {
  id: string;
  episodeId: string;
  takenAt: number;
  trigger: 'mutation_count' | 'time' | 'manual';
}

export async function listEpisodeSnapshots(
  episodeUuid: string,
): Promise<EpisodeSnapshot[]> {
  const res = await apiFetch(
    `/api/admin/episodes/${encodeURIComponent(episodeUuid)}/snapshots`,
  );
  if (!res.ok) throw new Error(`listEpisodeSnapshots failed: ${res.status}`);
  return res.json();
}

export async function restoreEpisodeSnapshot(
  episodeUuid: string,
  snapshotId: string,
): Promise<void> {
  const res = await apiFetch(
    `/api/admin/episodes/${encodeURIComponent(episodeUuid)}/snapshots/${encodeURIComponent(snapshotId)}/restore`,
    { method: 'POST' },
  );
  if (!res.ok) throw new Error(`restoreEpisodeSnapshot failed: ${res.status}`);
}
